import { LinearProgress } from '@mui/material'
import { AdminPrefix } from 'navigation/routes/admin/path'
import { PublicPrefix } from 'navigation/routes/public/path'
import { UserPrefix } from 'navigation/routes/user/path'
import React, { ReactElement, Suspense, lazy } from 'react'
import {
  Route,
  BrowserRouter as Router,
  Routes as RouterRoutes,
} from 'react-router-dom'

const AdminRoutes = lazy(() => import('navigation/routes/admin'))
const UserRoutes = lazy(() => import('navigation/routes/user'))
const PublicRoutes = lazy(() => import('navigation/routes/public'))

export const Routes = () => (
  <Router>
    <Suspense fallback={<LinearProgress />}>
      <RouterRoutes>
        <Route element={<AdminRoutes />} path={`${AdminPrefix}/*`} />
        <Route element={<UserRoutes />} path={`${UserPrefix}/*`} />
        <Route element={<PublicRoutes />} path={`${PublicPrefix}*`} />
      </RouterRoutes>
    </Suspense>
  </Router>
)

export enum SidebarCategories {
  Overview = 'Overview',
  Manage = 'Manage',
  Account = 'Account',
}

export interface RouteProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any
  path: string
  isProtected: boolean
  component: () => ReactElement
  showInSidebar: boolean
  label?: string
  sidebarCategory?: SidebarCategories
  showTemplate?: boolean
  showBackBtn?: boolean
}

export default Routes
